// Generated by CoffeeScript 1.6.3
"use strict";
var itsoftApp,
  __slice = [].slice;

window.itsoftApp = itsoftApp = {
  createNS: function(namespace) {
    var nsparts, parent, part, _i, _len;
    nsparts = namespace.split('.');
    parent = itsoftApp;
    if (nsparts[0] === 'itsoftApp') {
      nsparts = nsparts.slice(1);
    }
    for (_i = 0, _len = nsparts.length; _i < _len; _i++) {
      part = nsparts[_i];
      if (typeof parent[part] === "undefined") {
        parent[part] = {};
      }
      parent = parent[part];
    }
    return parent;
  },
  utils: {
    debouncer: function(func, timeout) {
      var timeoutID;
      if (timeout == null) {
        timeout = 200;
      }
      timeoutID = void 0;
      return function() {
        var args, scope;
        scope = this;
        args = arguments;
        clearTimeout(timeoutID);
        return timeoutID = setTimeout(function() {
          return func.apply(scope, Array.prototype.slice.call(args));
        }, timeout);
      };
    },
    b64_to_utf8: (function() {
      if (typeof window.atob === "function") {
        return function(str) {
          return decodeURIComponent(escape(window.atob(str)));
        };
      } else {
        setTimeout(function() {
          return itsoftApp.loadScript("/assets/scripts/base64.js", function() {
            return itsoftApp.utils.b64_to_utf8 = function(str) {
              return decodeURIComponent(escape(Base64.decode(str)));
            };
          });
        }, 0);
        return void 0;
      }
    })()
  },
  loadScript: function(url, callback, error) {
    var script;
    script = document.createElement('script');
    if (script.readyState) {
      script.onreadystatechange = function() {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null;
          if (typeof callback === 'function') {
            return callback();
          }
        }
      };
    } else {
      if (typeof error === "function") {
        script.onerror = error;
      }
      if (typeof callback === 'function') {
        script.onload = callback;
      }
    }
    script.src = url;
    return document.getElementsByTagName('body')[0].appendChild(script);
  },
  loadStyle: function(url) {
    var first, head, link;
    link = document.createElement('link');
    link.href = url;
    link.rel = "stylesheet";
    link.type = "text/css";
    head = document.getElementsByTagName('head')[0];
    first = head.firstChild;
    return head.insertBefore(link, first);
  },
  features: {
    transitionEventEnd: (function() {
      var el, t, transitions;
      el = document.createElement('fakeelement');
      transitions = {
        'transition': 'transitionend',
        'OTransition': 'oTransitionEnd',
        'MozTransition': 'transitionend',
        'WebkitTransition': 'webkitTransitionEnd'
      };
      for (t in transitions) {
        if (el.style[t] !== void 0) {
          $(el).remove();
          return transitions[t];
        }
      }
      return false;
    })(),
    placeholder: (function() {
      return "placeholder" in document.createElement("input");
    })()
  },
  initializedModules: [],
  createModule: function() {
    var dep, dependencies, initFunc, mName, module, options, _i, _j, _len, _ref;
    mName = arguments[0], options = 3 <= arguments.length ? __slice.call(arguments, 1, _i = arguments.length - 1) : (_i = 1, []), initFunc = arguments[_i++];
    if (typeof initFunc !== "function") {
      throw "Missing an initialization function for module '" + mName + "'";
    }
    module = itsoftApp.createNS("modules." + mName);
    module.__mName__ = mName;
    module.initialized = false;
    if (options.length && options[0].length) {
      dependencies = [];
      _ref = options[0];
      for (_j = 0, _len = _ref.length; _j < _len; _j++) {
        dep = _ref[_j];
        if (typeof dep === "string" && dependencies.indexOf(dep) < 0 && dep !== mName) {
          dependencies.push(dep);
        }
      }
      if (dependencies.length) {
        module.dependencies = dependencies;
      }
    }
    module.init = function(noDeps) {
      var depModule, e, initializedModules, t, _k, _len1;
      try {
        t = new Date();
        if (module.dependencies) {
          for (_k = 0, _len1 = dependencies.length; _k < _len1; _k++) {
            dep = dependencies[_k];
            depModule = itsoftApp.modules[dep];
            if (!depModule) {
              DEBUG && console.log("%c[modules] missed module " + dep + " as a dependency for module " + mName + ". (it's ok only if module is not required for this page)", "color: #BB6565; font-style: italic");
              return false;
            }
            if (depModule.initialized) {
              continue;
            }
            depModule.init();
            if (!depModule.initialized) {
              DEBUG && console.log("%c[modules] can't init module " + dep + " as a dependency for module " + mName + ". (it's ok only if module is not required for this page)", "color: #BB6565; font-style: italic");
              return false;
            }
          }
        }
        if (initFunc.call(module) !== false) {

          DEBUG && console.log("[module " + mName + "] module initialized in " + (new Date() - t) + " ms");
          module.initialized = true;
          initializedModules = itsoftApp.initializedModules || [];
          initializedModules.push(mName);
          return itsoftApp.initializedModules = initializedModules;
        }
      } catch (_error) {
        e = _error;
        return itsoftApp.errorHandler(e, {
          moduleName: mName
        });
      }
    };
    return module;
  },
  errorHandler: function(error, options) {
    var pre;
    pre = "[error]";
    if (options && options.moduleName) {
      pre += "[module " + options.moduleName + "]";
    }
    if (console && console.error) {
      return console.error("" + pre + "\n" + error + "\nNavigator: " + window.navigator.userAgent);
    }
  },
  commonVars: {
    $document: $("body, html"),
    $body: $("body"),
    $window: $(window),
    $wrapper: $(".l-wrapper")
  },
  initNewModule: function(){
    var m, module;

    for (m in itsoftApp.modules) {
      module = itsoftApp.modules[m];
      if (!module.initialized) {
        module.init();
      }

    }
  },
  removeModule: function(){
    var m, module;

    for (m in itsoftApp.modules) {
      module = itsoftApp.modules[m];
      module.initialized = false;
    }
  }
};

if (DEBUG) {
  if (typeof mocha !== "undefined") {
    mocha.setup("bdd");
  }
  if (typeof describe === "function") {
    describe("itsoftApp object tests", function() {
      it("Should be an object", function() {
        return expect(itsoftApp).to.be.an("object");
      });
      it("Should contain a loadScript function", function() {
        return expect(itsoftApp.loadScript).to.be.a("function");
      });
      it("Should contain a loadStyle function", function() {
        return expect(itsoftApp.loadStyle).to.be.a("function");
      });
      it("We can create a deep namespace scope with a string like 'ns1.ns2.ns3'", function() {
        var ns;
        ns = itsoftApp.createNS("ns1.ns2.ns3");
        expect(itsoftApp.ns1).to.be.an("object");
        expect(itsoftApp.ns1.ns2).to.be.an("object");
        expect(itsoftApp.ns1.ns2.ns3).to.be.an("object");
        return delete itsoftApp.ns1;
      });
      it("initializedModules must be defined from the start", function() {
        return expect(itsoftApp.initializedModules).to.be.an("array");
      });
      describe(".modules", function() {
        it("Should be a function to create modules", function() {
          return expect(itsoftApp.createModule).to.be.a("function");
        });
        it("We can simply create a single module", function() {
          var module, testFunc;
          testFunc = function() {
            return console.log('test module init');
          };
          module = itsoftApp.createModule("testmodule", testFunc);
          expect(module).to.be.equal(itsoftApp.modules.testmodule);
          return delete itsoftApp.modules.testmodule;
        });
        it("We can't create a module without initialization function", function() {
          var module;
          module = function() {
            return itsoftApp.createModule("testmodule");
          };
          return expect(module).to["throw"];
        });
        it("Each module must have an init function", function() {
          var module, _results;
          _results = [];
          for (module in itsoftApp.modules) {
            _results.push(expect(itsoftApp.modules[module].init).to.be.a("function"));
          }
          return _results;
        });
        return it("Should throw an exception if we try to initialize a module twice", function() {
          var mName, module, testFunc;
          mName = "testmodule" + Math.random() * 100;
          testFunc = function() {
            return 1;
          };
          module = itsoftApp.createModule(mName, testFunc);
          module.init();
          expect(module.init).to["throw"];
          return delete itsoftApp.modules[mName];
        });
      });
      describe(".features", function() {
        it("fileReader feature detection should return a boolean", function() {
          return expect(itsoftApp.features.fileReader).to.be.a("boolean");
        });
        it("\"ie\" must be a number (IE version, 4-9) or false (it also return false to IE 10+)", function() {
          var ie;
          ie = itsoftApp.features.ie;
          return expect(typeof ie === "number" || ie === false).to.be.equal(true);
        });
        it("hasTransform3d must return true or false, and add a class to <html>", function() {
          var hasTransform3d, htmlClassName;
          hasTransform3d = itsoftApp.features.hasTransform3d;
          expect(hasTransform3d).to.be.a("boolean");
          htmlClassName = document.getElementsByTagName("html")[0].className;
          if (hasTransform3d) {
            return expect(htmlClassName).to.contain("csstransforms3d");
          } else {
            return expect(htmlClassName).to.contain("no-csstransforms3d");
          }
        });
        it("transitionEventEnd must be a string or false", function() {
          var transitionEventEnd;
          transitionEventEnd = itsoftApp.features.transitionEventEnd;
          return expect(transitionEventEnd === false || typeof transitionEventEnd === "string").to.equal(true);
        });
        return it("placeholder must be true or false", function() {
          return expect(itsoftApp.features.placeholder).to.be.a("boolean");
        });
      });
      return describe(".commonVars", function() {
        it("$document must be defined as jQuery object", function() {
          expect(itsoftApp.commonVars.$document).to.not.be.undefined;
          return expect(itsoftApp.commonVars.$document).to.be["instanceof"](jQuery);
        });
        it("$body must be defined as jQuery object", function() {
          expect(itsoftApp.commonVars.$body).to.not.be.undefined;
          return expect(itsoftApp.commonVars.$body).to.be["instanceof"](jQuery);
        });
        it("$window must be defined as jQuery object", function() {
          expect(itsoftApp.commonVars.$window).to.not.be.undefined;
          return expect(itsoftApp.commonVars.$window).to.be["instanceof"](jQuery);
        });
        return it("$wrapper must be defined as jQuery object", function() {
          expect(itsoftApp.commonVars.$wrapper).to.not.be.undefined;
          return expect(itsoftApp.commonVars.$wrapper).to.be["instanceof"](jQuery);
        });
      });
    });
  }
}

$(function() {
  var $window, dColor, fTime, m, module, t;
  (function() {
    return $("a[href='#']").filter(function() {
      var obj;
      obj = $._data(this, "events");
      return typeof obj === "undefined" || "click" in obj;
    }).on("click", false);
  })();
  t = new Date();
  $window = itsoftApp.commonVars.$window;
  itsoftApp.initNewModule();
  $window.trigger("scroll").trigger("resize");
  if (DEBUG) {
    fTime = new Date() - t;
    dColor = fTime < 100 ? "green" : "red";
    console.log("%c[common] document ready event fired, " + itsoftApp.initializedModules.length + " modules initialized in " + fTime + " ms: " + itsoftApp.initializedModules, "color: " + dColor);
  }
  if (typeof mocha !== "undefined") {
    mocha.setup("bdd");
    return mocha.run();
  }
});

/*
//@ sourceMappingURL=itsoftapp.map
*/
